module.exports = __webpack_public_path__ + "img/logo-header.abad022a.png";